export function debounce (fn, wait) {
  let timer
  return function (...args) {
    if (timer) {
      clearTimeout(timer)
    }
    const context = this
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, wait)
  }
}

export function resolveMediaUrl (url) {
  if (!url) {
    return ''
  }
  if (/^https?:\/\//i.test(url)) {
    return url
  }
  const { port } = window.location
  const djangoOrigin = (port && port !== '8000' && port !== '80' && port !== '443')
    ? 'http://127.0.0.1:8000'
    : window.location.origin
  if (url.startsWith('/')) {
    return djangoOrigin + url
  }
  return url
}

export function resolveWatchoutApiRoot () {
  const { origin, port } = window.location
  if (port && port !== '8000' && port !== '80' && port !== '443') {
    return 'http://127.0.0.1:8000/watchout/'
  }
  return origin + '/watchout/'
}

export function resolvePlantsApiRoot () {
  const { origin, port } = window.location
  if (port && port !== '8000' && port !== '80' && port !== '443') {
    return 'http://127.0.0.1:8000/plants/'
  }
  return origin + '/plants/'
}

export function googleImagesSearchUrl (query) {
  const term = (query || '').trim()
  const search = term ? term + ' plant' : ''
  return 'https://www.google.com/search?tbm=isch&q=' + encodeURIComponent(search)
}

const VISITOR_KEY_STORAGE = 'plants4pets_visitor_key'

export function getVisitorKey () {
  let key = localStorage.getItem(VISITOR_KEY_STORAGE)
  if (key) {
    return key
  }
  if (window.crypto && window.crypto.randomUUID) {
    key = window.crypto.randomUUID()
  } else {
    key = 'v-' + Date.now() + '-' + Math.random().toString(16).slice(2)
  }
  localStorage.setItem(VISITOR_KEY_STORAGE, key)
  return key
}
